import { render, staticRenderFns } from "./SignatureRecords.vue?vue&type=template&id=925fcc6c&scoped=true"
import script from "./SignatureRecords.vue?vue&type=script&lang=js"
export * from "./SignatureRecords.vue?vue&type=script&lang=js"
import style0 from "./SignatureRecords.vue?vue&type=style&index=0&id=925fcc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925fcc6c",
  null
  
)

export default component.exports